import React from 'react'
import './App.css'
import LazyLoad from 'react-lazyload';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import logo from './smallerspinner.png';
import finalsharvard from "./finalist_photos/finalsharvard-min.webp"
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { CONFIG } from './config';

function Footer() {

  return (
    <div>
      {/* Our Mission Section */}
      <div style={{ padding: "80px 0", backgroundColor: "#fff" }}>
        <div className="container">
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "60px"
          }}>
            {/* Image */}
            <div style={{ flex: "1", minWidth: "300px" }}>
              <LazyLoad height={300} offset={100} once>
                <img
                  src={finalsharvard}
                  alt="IRO Finals at Harvard"
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    borderRadius: "16px",
                    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)"
                  }}
                />
              </LazyLoad>
            </div>

            {/* Content */}
            <div style={{ flex: "1", minWidth: "300px" }}>
              <h2 style={{
                fontSize: "2.5rem",
                fontWeight: "600",
                color: "#1a1a2e",
                marginBottom: "20px",
                letterSpacing: "-0.02em"
              }}>
                Our Mission
              </h2>
              <p style={{
                fontSize: "1.05rem",
                color: "#555",
                lineHeight: "1.8",
                marginBottom: "0"
              }}>
                Designed to inspire and challenge students aged 13-18 around the globe, the IRO aims to cultivate essential qualities of the research process. Unlike traditional science olympiads that delve into specific subjects, the IRO encourages students to build skills useful in any research discipline. Through this, participants foster a deeper understanding of the scientific process and build creativity, critical thinking, and analysis skills, forming a foundation for later success.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{
        backgroundColor: "#1a1a2e",
        color: "#fff",
        padding: "60px 0 30px 0"
      }}>
        <div className="container">
          {/* Top Section */}
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "40px",
            marginBottom: "50px"
          }}>
            {/* Logo & Description */}
            <div style={{ flex: "2", minWidth: "280px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
                <img src={logo} width="50px" alt="IRO Logo" style={{ borderRadius: "8px" }} />
                <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>International Research Olympiad</span>
              </div>
              <p style={{ fontSize: "0.95rem", color: "#a0a0a0", lineHeight: "1.7", maxWidth: "350px" }}>
                The premier Olympiad for student researchers, fostering critical thinking and scientific inquiry worldwide.
              </p>
              {/* Social Icons */}
              <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
                <a href={CONFIG.SOCIAL.TWITTER} target="_blank" rel="noreferrer" style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  transition: "background-color 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#004d99"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)"}
                >
                  <XIcon style={{ fontSize: "18px" }} />
                </a>
                <a href={CONFIG.SOCIAL.INSTAGRAM} target="_blank" rel="noreferrer" style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  transition: "background-color 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#004d99"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)"}
                >
                  <InstagramIcon style={{ fontSize: "18px" }} />
                </a>
                <a href={CONFIG.SOCIAL.LINKEDIN} target="_blank" rel="noreferrer" style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  transition: "background-color 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#004d99"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)"}
                >
                  <LinkedInIcon style={{ fontSize: "18px" }} />
                </a>
              </div>
            </div>

            {/* Links - About */}
            <div style={{ flex: "1", minWidth: "150px" }}>
              <h4 style={{ fontSize: "0.9rem", fontWeight: "600", marginBottom: "20px", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                About
              </h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                <li style={{ marginBottom: "12px" }}><a href="/about" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>What is the IRO?</a></li>
                <li style={{ marginBottom: "12px" }}><a href="/about#updates" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>Recent Updates</a></li>
                <li style={{ marginBottom: "12px" }}><a href="/about#board" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>Board of Advisors</a></li>
              </ul>
            </div>

            {/* Links - Exam Info */}
            <div style={{ flex: "1", minWidth: "150px" }}>
              <h4 style={{ fontSize: "0.9rem", fontWeight: "600", marginBottom: "20px", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                Exam Info
              </h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                <li style={{ marginBottom: "12px" }}><a href="/about-iro" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>About the Exam</a></li>
                <li style={{ marginBottom: "12px" }}><a href="/rules-and-regulations" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>Rules & Regulations</a></li>
                <li style={{ marginBottom: "12px" }}><a href="/registration-and-eligibility" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>Registration</a></li>
              </ul>
            </div>

            {/* Links - Student Center */}
            <div style={{ flex: "1", minWidth: "150px" }}>
              <h4 style={{ fontSize: "0.9rem", fontWeight: "600", marginBottom: "20px", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                Students
              </h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                <li style={{ marginBottom: "12px" }}><a href="/start-iro-club" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>Start an IRO Club</a></li>
                <li style={{ marginBottom: "12px" }}><a href="/practice-exams" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>Practice Exams</a></li>
                <li style={{ marginBottom: "12px" }}><a href="/curriculum" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>Curriculum</a></li>
              </ul>
            </div>

            {/* Links - Media */}
            <div style={{ flex: "1", minWidth: "150px" }}>
              <h4 style={{ fontSize: "0.9rem", fontWeight: "600", marginBottom: "20px", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                Media
              </h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                <li style={{ marginBottom: "12px" }}><a href="/press-releases" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>Press Releases</a></li>
                <li style={{ marginBottom: "12px" }}><a href="/media-kit" style={{ color: "#a0a0a0", textDecoration: "none", fontSize: "0.9rem" }}>Media Kit</a></li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div style={{ height: "1px", backgroundColor: "rgba(255,255,255,0.1)", marginBottom: "30px" }}></div>

          {/* Bottom Section */}
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px"
          }}>
            <p style={{ fontSize: "0.85rem", color: "#a0a0a0", margin: 0 }}>
              © {new Date().getFullYear()} International Research Olympiad. All rights reserved.
            </p>
            <div style={{ display: "flex", gap: "24px", flexWrap: "wrap", alignItems: "center" }}>
              <span style={{ fontSize: "0.85rem", color: "#a0a0a0", display: "flex", alignItems: "center", gap: "6px" }}>
                <EmailOutlinedIcon style={{ fontSize: "16px" }} /> {CONFIG.CONTACT_EMAIL}
              </span>
              <span style={{ fontSize: "0.85rem", color: "#a0a0a0", display: "flex", alignItems: "center", gap: "6px" }}>
                <FmdGoodOutlinedIcon style={{ fontSize: "16px" }} /> Cambridge, MA
              </span>
              <a href="/terms-of-service" style={{ fontSize: "0.85rem", color: "#a0a0a0", textDecoration: "none", display: "flex", alignItems: "center", gap: "6px" }}>
                <AssignmentOutlinedIcon style={{ fontSize: "16px" }} /> Terms
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer;
